<template>
  <div class="usermessage-container">
    <div class="tabbar-container">
      <div class="popup-back"
           @click="Back">
        <van-icon name="arrow-left" />
        返回
      </div>
      信息完善
    </div>

    <div class="message-container">
      <van-cell-group inset>
        <van-field @input="showMessage = false"
                   v-model="IdCard"
                   label="身份证号"
                   placeholder="请输入身份证号"
                   center
                   clearable>
          <template #button>
            <van-button @click="findStudent()"
                        size="small"
                        type="primary">查询</van-button>
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group v-show="showMessage"
                      inset>
        <van-field v-model="student.StudentName"
                   label="姓名"
                   placeholder="请输入姓名"
                   input-align="right" />
        <van-field v-model="student.PhoneNumber"
                   label="电话号码"
                   placeholder="请输入电话号码"
                   input-align="right" />
        <!-- <van-field v-model="student.Company" label="所属单位" readonly @click="findCompany" placeholder="请选择所属单位" input-align="right" /> -->
        <van-field v-model="student.StudentType"
                   label="类别"
                   readonly
                   @click="showStudentType = true"
                   placeholder="请选择类别"
                   input-align="right" />
        <van-field v-model="student.Subject"
                   label="考培科目"
                   readonly
                   @click="showSubject = true"
                   placeholder="请选择考培科目"
                   input-align="right" />
        <van-field v-model="student.Unit"
                   label="部门"
                   readonly
                   @click="showUnit1 = true"
                   placeholder="请选择部门"
                   input-align="right" />
        <van-field v-model="student.Unit2"
                   label="班组"
                   readonly
                   @click="showBz()"
                   placeholder="请选择班组"
                   input-align="right" />
        <van-field readonly
                   label="电子签名">
          <template #button>
            <van-button @click="showSign = true"
                        size="small"
                        type="primary">签名</van-button>
          </template>
        </van-field>
        <div class="sign-view"
             v-if="student.SignUrl"><van-image :src="student.SignUrl" /></div>
        <div class="checkout"
             @click="saveMessage">保存</div>
      </van-cell-group>
    </div>

    <van-popup v-model="showCompany"
               round
               position="bottom">
      <van-picker title="所属单位"
                  show-toolbar
                  :columns="cData"
                  @confirm="confirmCompany"
                  @cancel="onCancel" />
    </van-popup>
    <van-popup v-model="showStudentType"
               round
               position="bottom">
      <van-picker title="员工类别"
                  show-toolbar
                  value-key="Name"
                  :columns="stData"
                  @confirm="confirmStudentType"
                  @cancel="onCancel" />
    </van-popup>
    <van-popup v-model="showSign"
               @close="handleReset"
               round
               position="bottom">
      <div class="sign-container">
        <span>签名</span>
        <vue-esign style="border-radius: 15px; margin-top: 10px"
                   ref="esign"
                   :width="800"
                   :height="450"
                   :isCrop="isCrop"
                   :lineWidth="lineWidth"
                   :lineColor="lineColor"
                   :bgColor.sync="bgColor" />
        <div class="sign-button">
          <van-button size="small"
                      style="margin-right: 10px"
                      @click="handleReset"
                      type="default">清空</van-button>
          <van-button size="small"
                      @click="handleGenerate"
                      type="info">确认</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showSubject"
               position="bottom"
               round
               :lock-scroll="false">
      <van-cascader v-model="student.SubjectIDSingle"
                    title="请选择科目"
                    :options="SubjectData"
                    active-color="#1989fa"
                    :field-names="{
          text: 'SubjectName',
          value: 'SubjectID',
          children: 'children',
        }"
                    @close="showSubject = false"
                    @finish="onFinish" />
    </van-popup>

    <van-popup v-model="showUnit1"
               position="bottom"
               round
               :lock-scroll="false">
      <van-cascader v-model="student.UnitIDSingle"
                    title="请选择部门"
                    :options="unit1List"
                    active-color="#1989fa"
                    :field-names="{
          text: 'UnitName',
          value: 'UnitID',
          children: 'children',
        }"
                    :allow-select-parent="true"
                    @close="showUnit1 = false"
                    @finish="onFinishUnit1" />
    </van-popup>

    <van-popup v-model="showUnit2"
               position="bottom"
               round
               :lock-scroll="false">
      <van-cascader v-model="student.UnitIDSingle2"
                    title="请选择班组"
                    :options="unit2List"
                    active-color="#1989fa"
                    :field-names="{
          text: 'UnitName',
          value: 'UnitID',
          children: 'children',
        }"
                    @close="showUnit2 = false"
                    @finish="onFinishUnit2" />
    </van-popup>

    <van-overlay :show="addLoading"
                 :custom-style="{ background: 'rgba(0,0,0,0.2)' }">
      <van-loading style="position: absolute; top: calc(50% - 25px); left: calc(50% - 30px)"
                   size="50px"
                   color="#0094ff"
                   vertical
                   text-color="#0094ff">加载中</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import vueEsign from "vue-esign";
export default {
  name: "user",
  components: { vueEsign },
  computed: {},
  data () {
    return {
      addLoading: false,
      // 所属单位选择
      showCompany: false,
      // 员工类别选择
      showStudentType: false,
      // 考培科目选择
      showSubject: false,
      // 部门选择
      showUnit1: false,
      // 班组选择
      showUnit2: false,
      // 完善信息显隐
      showMessage: false,
      // 所属单位集合
      cData: [],
      // 员工类别集合
      stData: [],
      // 考培科目树
      SubjectData: [],
      // 查询的身份证号
      IdCard: "",
      student: {
        StudentID: "",
        Company: "",
        StudentName: "",
        PhoneNumber: "",
        IdCard: "",
        StudentTypeID: "",
        StudentType: "",
        SubjectIDSingle: "",
        SubjectID: "",
        Subject: "",
        Unit: "",
        UnitID: "",
        UnitIDSingle: "",
        Unit2: "",
        UnitID2: "",
        UnitIDSingle2: "",
        SignUrl: "",
      },

      // 考培科目树内容
      bmList: [],
      kmList: [],
      // 部门树内容
      unit1List: [],
      // 班组树内容
      unit2List: [],

      showSign: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      isCrop: false,
    };
  },
  watch: {},
  created () { },
  async mounted () {
    this.IdCard = localStorage.getItem("IdCard");

    this.addLoading = true;
    setTimeout(() => {
      this.addLoading = false;
    }, 20000);

    await this.loadData();
    await this.findStudent();

    this.addLoading = false;
  },
  destroyed () { },
  methods: {
    handleReset () {
      this.$refs.esign.reset();
    },
    handleGenerate () {
      this.$refs.esign
        .generate()
        .then((res) => {
          this.student.SignUrl = res;
          this.showSign = false;
        })
        .catch(() => {
          this.$toast("请在签字版上签名后保存");
        });
    },
    async confirmCompany (row) {
      this.student.Company = row;
      this.onCancel();
    },
    confirmStudentType (row) {
      this.student.StudentTypeID = row.ID;
      this.student.StudentType = row.Name;

      // if (row.ID === "1adce98b-8204-46d6-92a4-645bbec14720") {
      //   this.SubjectData = this.bmList;
      // } else if (row.ID === "248d881d-9bfd-4122-8798-b46adbdb768f") {
      //   this.SubjectData = this.kmList;
      // }
      this.SubjectData = this.kmList;

      this.student.SubjectIDSingle = "";
      this.student.SubjectID = "";
      this.student.Subject = "";
      this.onCancel();
    },
    onCancel () {
      this.showCompany = false;
      this.showStudentType = false;
    },
    findCompany () {
      this.showCompany = true;
    },
    Back () {
      this.$emit("fatherMethod");
    },
    async loadData () {
      // 所属单位查询
      // const companyData = await this.$store.dispatch("api/GetAllCompany", {});
      // if (companyData.success) {
      //   companyData.rows.forEach((c) => {
      //     this.cData.push(c.Name);
      //   });
      // }

      // 员工类别查询
      const StudentTypeData = await this.$store.dispatch("api/getStudentType", {});
      this.stData = StudentTypeData.rows;

      // 考培科目查询
      // const bm = await this.$store.dispatch("api/GetFunTree2", { SubjectID: "f401af9b-f39b-475c-be03-d0791f85ceee" });
      // this.bmList = bm.data;
      const km = await this.$store.dispatch("api/GetFunTree2", { SubjectID: "bd326329-4db6-481a-b665-ad3df806cb57" });
      this.kmList = km.data;
      // 部门查询
      // const bmData = await this.$store.dispatch("api/GetUnitTree", {});
      // this.unit1List = bmData.data[0].children;
      // this.unit1List.shift();

      //部门查询新修改，只保留第一级父节点
      const bmData = await this.$store.dispatch("api/GetBm", { PageIndex: 1, PageSize: 500 });
      let bmDataNew = this.markLeafUnselectable(bmData.data)
      this.unit1List = bmDataNew;
    },
    // 根据身份证号查用户信息，如果没注册过，则保存信息为新增。
    async findStudent () {
      // 点击查询先把提交内容设置为空
      this.student = {
        StudentID: "",
        Company: "",
        StudentName: "",
        PhoneNumber: "",
        IdCard: "",
        StudentTypeID: "",
        StudentType: "",
        SubjectIDSingle: "",
        SubjectID: "",
        Subject: "",
        Unit: "",
        UnitID: "",
        UnitIDSingle: "",
        Unit2: "",
        UnitID2: "",
        UnitIDSingle2: "",
        SignUrl: "",
      };

      if (!this.IdCard) {
        this.$toast("请填写身份证号");
        return;
      }
      // 身份证验证。
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.IdCard)) {
        this.$toast("身份证格式错误");
        return false;
      }

      const student = await this.$store.dispatch("api/GetSutentById", {
        IdCard: this.IdCard,
      });

      if (student.data && student.data.length > 0) {
        this.student = student.data[0];

        // 部门科目树赋值
        this.SubjectData = this.kmList;
        // if (this.student.StudentTypeID === "1adce98b-8204-46d6-92a4-645bbec14720") {
        //   this.SubjectData = this.bmList;
        // } else if (this.student.StudentTypeID === "248d881d-9bfd-4122-8798-b46adbdb768f") {
        //   this.SubjectData = this.kmList;
        // }
      }
      // 点击查询可以显示保存表单
      this.showMessage = true;
    },
    showBz () {
      if (this.student.Unit && this.student.UnitID) {
        this.showUnit2 = true;
      } else {
        this.$toast("请选择部门");
      }
    },
    async saveMessage () {
      if (!this.student.StudentName) {
        this.$toast("请填写姓名");
        return;
      }
      if (!this.student.PhoneNumber) {
        this.$toast("请填写手机号");
        return;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.student.PhoneNumber)) {
        this.$notify({ type: "warning", message: "手机号格式错误" });
        return;
      }
      if (!this.IdCard) {
        this.$toast("请填写身份证号");
        return;
      }
      // 身份证验证。
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.IdCard)) {
        this.$toast("身份证格式错误");
        return false;
      }
      // if (await this.CheckStudentIdCard()) {
      //   this.$toast("该身份证号已经其有他用户使用");
      //   return false;
      // }
      // if (!this.student.Company) {
      //   this.$toast("请选择所属单位");
      //   return;
      // }
      if (!this.student.StudentType || !this.student.StudentTypeID) {
        this.$toast("请选择员工类别");
        return;
      }
      if (!this.student.Subject || !this.student.SubjectID) {
        this.$toast("请选择考培科目");
        return;
      }
      if (!this.student.Unit || !this.student.UnitID) {
        this.$toast("请选择部门");
        return;
      }
      if (!this.student.Unit2 || !this.student.UnitID2) {
        this.$toast("请选择班组");
        return;
      }
      if (!this.student.SignUrl) {
        this.$toast("请电子签名");
        return;
      }

      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 20000);

      // 修改时候身份证赋值
      this.student.IdCard = this.IdCard;
      this.student.OldIdCard = this.IdCard;

      const url = `${this.student.StudentID === "" ? "api/StudentsAdd" : "api/StudentsEdit"}`;
      // 修改、保存
      this.$store
        .dispatch(url, this.student)
        .then((response) => {
          if (response.success) {
            this.addLoading = false;
            localStorage.setItem("IdCard", this.IdCard);
            this.$toast("信息完善成功");
            this.Back();
          } else {
            this.addLoading = false;
            this.$toast(response.message);
          }
        })
        .catch((error) => {
          this.addLoading = false;
          console.log(error);
        });
    },
    onFinish ({ selectedOptions, tabIndex }) {
      this.student.Subject = selectedOptions[tabIndex].SubjectName;
      this.student.SubjectID = selectedOptions.map((a) => a.SubjectID).join(",");

      this.showSubject = false;
    },
    async onFinishUnit1 ({ selectedOptions, tabIndex }) {

      this.student.Unit = selectedOptions[tabIndex].UnitName;
      this.student.UnitID = selectedOptions.map((a) => a.UnitID).join(",");

      this.showUnit1 = false;

      this.addLoading = true;

      this.student.Unit2 = "";
      this.student.UnitID2 = "";
      this.student.UnitIDSingle2 = "";
      this.student.unit2List = [];

      setTimeout(() => {
        this.addLoading = false;
      }, 20000);
      // 班组查询
      const bzData = await this.$store.dispatch("api/GetUnitTree", { UnitID: selectedOptions[tabIndex].UnitID });
      this.unit2List = bzData.data;

      this.addLoading = false;
    },
    markLeafUnselectable (nodes) {
      return nodes
        .map(node => {
          const hasChildren = Array.isArray(node.children) && node.children.length > 0;
          if (hasChildren) {
            // 保留第一层父节点，去掉其 children
            return {
              ...node,
              children: null, // 或者可以不写 children 字段
            };
          }
          // 是叶子节点，过滤掉
          return null;
        })
        .filter(Boolean);
    },
    onFinishUnit2 ({ selectedOptions, tabIndex }) {
      this.student.Unit2 = selectedOptions[tabIndex].UnitName;
      this.student.UnitID2 = selectedOptions.map((a) => a.UnitID).join(",");

      this.showUnit2 = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.usermessage-container {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(#2d8efc, #1ccaa3);
  overflow-x: hidden;
}
.tabbar-container {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 1rem;
  position: relative;
  font-size: 1.1rem;

  .popup-back {
    position: absolute;
    left: 20px;
    top: 1px;
  }
}

.message-container {
  background: #ffffff;
  padding-top: 1rem;
  border-radius: 10px;
  width: 90%;
  margin-left: 5%;
  margin-top: 3.5rem;
}

/deep/ .van-cell-group--inset {
  margin: 0;
}

/deep/ .van-cell {
  width: 100% !important;
  margin: 0 !important;
}

.checkout {
  width: 90%;
  height: 44px;
  margin-left: 5%;
  border-radius: 999px;
  margin-bottom: 1rem;
  display: flex;
  align-items: row;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(270deg, #2d8efc, #1ccaa3);
  color: #ffffff;
  font-size: 1rem;
}

.sign-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;

  .sign-button {
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.sign-view {
  padding: 15px;
  box-sizing: border-box;
}
</style>
